<!-- 资金使用量前五名机具 -->
<template>
  <div class="rank">
    <div class="rank-row" v-for="(item, index) in fundRank">
      <div class="rank-row-top">
        <div class="rank-row-top-left">
          <img :src="require(`../../../../assets/images/governmentAffairs/purchaseAllowance/icon_ranking_${index + 1}.png`)"></img>
          <p>{{item.mcc}}</p>
        </div>
        <div class="rank-row-top-right">
          <img class="img-left-top" src="../../../../assets/images/governmentAffairs/purchaseAllowance/bg_num_lt.png"></img>
          <img class="img-left-bottom" src="../../../../assets/images/governmentAffairs/purchaseAllowance/bg_num_ld.png"></img>
          <img class="img-right-top" src="../../../../assets/images/governmentAffairs/purchaseAllowance/bg_num_rt.png"></img>
          <img class="img-right-bottom" src="../../../../assets/images/governmentAffairs/purchaseAllowance/bg_num_rd.png"></img>
          <p class="number">{{item.centralSubsidy || 0 | toThousandFloatFilter}}<span class="unit">万元</span></p>
        </div>  
      </div>
      <div class="rank-row-bottom">
        <div :style="getStyle(item, index)"></div>
      </div>
    </div>
  </div>
</template>

<script>
// import { getAreaMachineryNum } from '@/api/vehicleDistribution'
export default {
  name: 'fundRank',
  props: {
    fundRank: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      colorList: [
        'background: linear-gradient(90deg, #DE9800, #FFDC91);',
        'background: linear-gradient(90deg, #DEDE00, #FFFF91);',
        'background: linear-gradient(90deg, #00DE8D, #91FFD7);',
        'background: linear-gradient(90deg, #00DEC4, #91FFF2);',
        'background: linear-gradient(90deg, #00DE59, #91FFBD);'
      ]
    }
  },
  methods: {
    getStyle(item,index) {
      return this.colorList[index] + ';width:' + item.ratio + '%';
    },
  },
  mounted() {
     
  }
}
</script>
<style lang='scss' scoped>
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
@function fontSize($px) {
  @return 100vw * $px / 1920;
}

.rank {
  display: flex;
  flex-direction: column;
  font-family: Microsoft YaHei;
  padding-left: vw(9);
  width: 100%;
  .rank-row {
    .rank-row-top {
      display: flex;
      justify-content: space-between;
      margin-top: vh(9);
      margin-bottom: vh(4);
      .rank-row-top-left {
        display: flex;
        flex: 1;
        img {
          width: vw(53);
          height: vh(22);
        }
        p {
          margin-top: vh(-2);
          margin-left: vw(8);
          font-size: fontSize(16);
          color: #FFFFFF;
        }
      }
      .rank-row-top-right {
        position: relative;
        padding: 0 vw(7);
        background: url("../../../../assets/images/governmentAffairs/purchaseAllowance/bg_num.png");
        font-size: fontSize(14);
        color: #5EFF97;
        .img-left-top {
          position: absolute;
          top: 0;
          left: 0;
        }
        .img-left-bottom {
          position: absolute;
          left: 0;
          bottom: 0;
        }
        .img-right-top {
          position: absolute;
          top: 0;
          right: 0;
        }
        .img-right-bottom {
          position: absolute;
          right: 0;
          bottom: 0;
        }
        .number {
          line-height: vh(22);
          padding-top: vh(3);
        }
        .unit {
          margin-left: vw(4);
          font-size: fontSize(13);
          color: rgba(80, 166, 110, 0.6);
        }
      }
    }
    .rank-row-bottom {
      display: flex;
      align-items: center;
      width: 100%;
      height: vh(13);
      padding: vh(4) vw(4);
      background: rgba(255,255,255,0);
      border: 1px solid rgba(62,101,75,0.74);
      div {
        width: 100%;
        height: vh(5);
      }
    }
  }
}

</style>
